import FadeInSection from '$components/FadeInSection/FadeInSection';
import cn from 'classnames';
import { HTMLAttributes, useState } from 'react';

import { IGallery } from './';
import { GalleryContent } from './GalleryContent';
import { GalleryCounter } from './GalleryCounter';
import { GalleryImage } from './GalleryImage';
import { GalleryProgress } from './GalleryProgress';

export function Gallery(props: IGallery & HTMLAttributes<HTMLElement>) {
  const { className, content, ...rest } = props;
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [lastDirection, setLastDirection] = useState('right');

  const galleryItems = content.length;

  const changeItem = (trigger) => {
    setLastDirection(trigger > activeSlideIndex ? 'right' : 'left');
    setActiveSlideIndex(trigger);
  };

  const [height, setHeight] = useState(0);
  const containerHeight = (newHeight) => {
    if (newHeight > height) setHeight(newHeight);
  };

  return (
    <FadeInSection className={cn('overflow-x-hidden')}>
      <div className="lg:mt-32 flex flex-row justify-center">
        <div className={`grid-standard `}>
          <div className={` col-span-4 lg:col-span-12`}>
            <div
              className={cn(
                'relative w-full flex flex-col justify-center items-stretch',
              )}
            >
              <div className={cn('flex h-full flex-col justify-stretch')}>
                <div
                  className={cn(
                    'flex w-full flex-row flex-wrap justify-stretch lg:justify-between items-center',
                  )}
                >
                  <div
                    className={cn(
                      'flex w-full lg:w-2/3 flex-col items-end justify-stretch lg:justify-center',
                    )}
                  >
                    <div
                      className={cn(
                        'relative block lg:flex w-full lg:grow-0 items-center aspect-w-16 aspect-h-9 [&>img]:h-full',
                      )}
                    >
                      {content.map((item, index) => {
                        return (
                          <GalleryImage
                            activeSlideIndex={activeSlideIndex}
                            count={galleryItems}
                            direction={lastDirection}
                            key={index}
                            active={index === activeSlideIndex}
                            index={index}
                            assets={item.assetsCollection.items}
                          />
                        );
                      })}
                    </div>
                  </div>
                  <div
                    {...rest}
                    className={cn(
                      className,
                      'flex w-full mt-8 lg:mt-0 lg:w-auto lg:grow flex-col items-start justify-center lg:h-full relative',
                    )}
                  >
                    <GalleryProgress
                      colour="#DCDCDC"
                      stroke={2}
                      progress={100}
                    />
                    <GalleryProgress
                      stroke={4}
                      colour="#D63D00"
                      progress={((activeSlideIndex + 1) / galleryItems) * 100}
                    />
                    <GalleryCounter
                      count={galleryItems}
                      activeIndex={activeSlideIndex}
                      action={changeItem}
                    />
                  </div>
                </div>
                <div
                  {...rest}
                  className={cn(
                    className,
                    'relative mt-8 lg:mt-0 lg:py-8 flex w-full lg:w-2/3 flex-col items-start justify-start min-h-[160px]',
                  )}
                >
                  <div style={{ height: height }}>
                    {content.map((item, index) => {
                      return (
                        <GalleryContent
                          heights={containerHeight}
                          key={index}
                          active={index === activeSlideIndex}
                          index={index}
                          item={item.text}
                          type={'light'}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
}
